export class AddressModel {
  city?: string
  state?: string
  postalCode?: string

  constructor(params: any) {
    this.city = params?.city
    this.state = params?.state
    this.postalCode = params?.postalCode
  }

  get label() {
    if (this.city && this.state && this.postalCode) {
      return `${this.city}, ${this.state} ${this.postalCode}`
    }
    if (this.city && this.state) {
      return `${this.city}, ${this.state}`
    }
  }
}
